/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


$(window)
.resize(function() {
  //get sizes
  footernav();
 
})
.resize();
$(document).ready(function() {
  $('.js-layout-slider-two').slick({
    slidesToShow: 4,
    infinite: false,
    responsive: [
        {
        breakpoint: 1400,
        settings: {
          unslick: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          infinite: false,
          centerMode: false,
          centerPadding: '20px',
          slidesToShow: 2
        }
      }
    ]
});
   $('.sw-deal-slider').slick({
    slidesToShow: 2,
    infinite: false,
    arrows: true,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 680,
        settings: {
          arrows: false,
          infinite: false,
          centerMode: false,
          centerPadding: '20px',
          slidesToShow: 1
        }
      }
    ]
});
  
  

  footernav();
});
                  
function footernav() {
  winWidth = $(window).width();
  theme.mobileBrkp = 768;
  theme.cstTab = 1024;
  stClick= $('.footer-nav__title');
  if (winWidth >= theme.mobileBrkp) {
  	$(stClick).parent().removeClass('fnav-active');
  } else {
    $(stClick).click(function(){
      $(this).parent().toggleClass('fnav-active');
    });
  }
  if (winWidth >= theme.cstTab) {
    $(".js-mobile-draw-icon").hide();
    $(".header-navs").show();
  } else {
     ///console.log('mob');
    $(".js-mobile-draw-icon").show();
    $(".header-navs").hide();
    
  }
  $('.primary-nav__link').each(function(e){
    var kd = jQuery(this).position().left;
    //$('.nav__sub-wrap.single').css({"left": kd - 20 });
    $(this).next().children('.nav__sub-wrap.single').css({"left": kd - 20 });
  });
  
  $('.section__address').magnificPopup({
    items: {
        src: ".js-address-draw"
      },
      type: "inline",
      mainClass: "mfp-medium",
      fixedContentPos: true,
      removalDelay: 200
  });
  
  $('.moverlay').click(function() {
    $(this).parent('.nav__sub').hide();
  });
  
  $('.primary-nav__item--sub').hover(function() {
    $(this).children('.nav__sub').show();
  });
}


// code for reorder

this.reorder = new function(){
  var self = this;

  this.pushQueue = function(i, data, el){
    
    //LOW STOCK -- add as many as possible if stock is below requested ammount
    if(data[i].check_inventory){
      data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
    }
    
    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      data: {
        quantity: data[i].quantity,
        id: data[i].id
      },
      complete: function(res){
        if(i >= data.length - 1){
          //products from queue are now added to the cart -> stop loading signal and go to cart
          el.removeClass('loading');
          window.location.href = '/cart';
          return;
        }else{
          // Calls are async as required by Shopify Docs
       	  self.pushQueue(i+1, data, el);
        }
      }
    });
  }

  this.listen = function(){
    var el = $(this);
    var ids = el.attr('data-variant-ids').split(',');
    var quantities = el.attr('data-variant-quantities').split(',');
    var inventories = el.attr('data-variant-inventories').split(',');
    var inventory_policies = el.attr('data-variant-inventory-policies').split(',');
    var inventory_trackers = el.attr('data-variant-inventory-trackers').split(',');
    ids.splice(-1, 1);
    quantities.splice(-1, 1);
    inventories.splice(-1, 1);
    inventory_policies.splice(-1, 1);
    inventory_trackers.splice(-1, 1);
    
    var data = [];
    for(var i=0; i<ids.length; i++){
      data.push({
        id: ids[i],
        quantity: quantities[i],
        inventory: inventories[i],
        check_inventory: (inventory_policies[i] == "deny" && inventory_trackers[i] != "")
      });
    }
    el.addClass('loading');
    self.pushQueue(0, data, el);
  }
  
  this.init = function(){
    $('.reorder-btn').on('click', self.listen);
  }
}
$(reorder.init);

